/* eslint-disable import/prefer-default-export */
export const quotationFormQueryKeys = {
  config: (id: string) => ["quotation-form", "config", id],
};
